import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import getMetadata from '@/shared/api/product/getMetadata';
import viewProducts from '@/shared/api/product/viewProducts';
import useRedirectLogin from '@/shared/hooks/useRedirectLogin';
import Metadata from '@/shared/types/metadata/index.type';
import Product from '@/shared/types/products/product.type';

const useFetchProductAndMetadataForEdit = () => {
  const redirectLogin = useRedirectLogin();
  const navigate = useNavigate();
  const { id: productId = '' } = useParams();

  const [product, setProduct] = useState<Product | null>(null);
  const [metadata, setMetadata] = useState<Metadata | null>(null);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [apiError, setApiError] = useState<string | null>(null);

  useEffect(() => {
    const fetchProduct = async () => {
      setIsPageLoading(true);
      const response = await viewProducts({
        body: {
          search: [
            {
              product_id: {
                cop: ['='],
                value: productId,
              },
            },
          ],
        },
        onUnauthorized: redirectLogin,
      });

      if (response.success) {
        const product = response.data[0];
        setProduct(product);
        setIsPageLoading(false);
      } else {
        setApiError(response.msg);
      }
    };

    const fetchMetadata = async () => {
      setIsPageLoading(true);
      const response = await getMetadata(redirectLogin);

      if (response.success) {
        setMetadata(response.data);
        setIsPageLoading(false);
      } else {
        setApiError(response.msg);
      }
    };

    void fetchProduct();
    void fetchMetadata();
  }, [navigate, productId, redirectLogin]);

  return {
    product,
    metadata,
    productId,
    isPageLoading,
    apiError,
  };
};

export default useFetchProductAndMetadataForEdit;
